/**
 * Created by matheusmorett on 9/11/17.
 */
import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import Lightbox from 'react-images';
import {Parallax, Background} from 'react-parallax';
import Button from './../../Button';
import Utils from 'utils/Utils';

import './AdventureBanner.scss';


@inject('AuthStore', 'ApplicationStore')
@observer
class AdventureBanner extends Component {

    static defaultProps = {
        setFavorite: () => {
        },
        unsetFavorite: () => {
        },
        setFeedback: () => {
        },
        unsetFeedback: () => {
        },
    };

    constructor(props) {
        super(props);

        const {ApplicationStore} = this.props;

        ApplicationStore.setMenuStyle({
            marginBottom: "-113px",
            zIndex: 999
        });

        this.state = {
            lightboxIsOpen: false,
            currentImage: 0,
            paralaxEnable: (window.innerWidth >= 1577)
        };

        this.updateDimensions = this.updateDimensions.bind(this);
    }

    componentDidMount() {
        window.addEventListener("resize", this.updateDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions);
    }

    updateDimensions() {
        this.setState({
            paralaxEnable: (document.documentElement.clientWidth >= 1577)
        });
    }

    componentWillReceiveProps(props) {
        this.setState({...props});
    }

    openLightbox() {
        this.setState({
            lightboxIsOpen: true
        });
    }

    closeLightbox() {
        this.setState({
            lightboxIsOpen: false
        });
    }

    gotoPrevious() {
        this.setState({
            currentImage: this.state.currentImage - 1,
        });
    }

    gotoNext() {
        this.setState({
            currentImage: this.state.currentImage + 1,
        });
    }

    likeAdventure() {
        if (!this.props.AuthStore.isLogged) {
            this.openModal(1)
        }
    }

    handleFavorite() {

        if (this.props.AuthStore.isLogged) {
            const params = {
                fk_user: this.props.AuthStore.authUser.pk_user,
                fk_adventure: this.props.Adventure.pk_adventure
            };
            if (this.props.Adventure.user_favorite.find(u => u.fk_user === this.props.AuthStore.authUser.pk_user) === undefined) {
                this.props.setFavorite(params);
            } else {
                this.props.unsetFavorite(params);
            }
        } else {
            this.openModal(1);
        }

    }

    render() {

        const {Adventure, ApplicationStore} = this.props;
        const {paralaxEnable} = this.state;
        const size = Utils.getWindowBreakpoint();
        let imageStyle;
        let images;

        if (Adventure) {
            imageStyle = {backgroundImage: `url(${this.props.Adventure.banner[`url_${size}`]})`}
            images = [];

            Adventure.images.map(
                (i, index) => {
                    images.push({
                        id: index, src: i[`url_${size}`]
                    });
                }
            );

        } else {
            imageStyle = {};
            images = [];
        }

        return (
            <section id="AdventureBanner" className={"AdventureBanner not-parallax"}
                     style={imageStyle}>
                <div className="container">
                    <div className="wrapper">
                        <div className="banner">
                            {/* {(Adventure && Adventure.images.length > 0 &&
                                <div className="images">
                                    <Button size="x-sm" value={
                                        <div>
                                            <span className="icon icon-camera2"/>
                                            Ver fotos
                                        </div>
                                    } onClick={this.openLightbox.bind(this)}/>
                                </div>
                            )} */}
                        </div>
                        {/* <Lightbox
                            images={images}
                            currentImage={this.state.currentImage}
                            isOpen={this.state.lightboxIsOpen}
                            onClickPrev={this.gotoPrevious.bind(this)}
                            onClickNext={this.gotoNext.bind(this)}
                            onClose={this.closeLightbox.bind(this)}
                            theme={{
                                close: {
                                    fill: '#FD8283',
                                    opacity: 0.6,
                                    transition: 'all 200ms',
                                    ':hover': {
                                        opacity: 1,
                                    },
                                    text: "FECHAR"
                                }
                            }}
                        /> */}
                    </div>
                </div>
                
            </section>
        )

    }
}

export default AdventureBanner;